/* stylelint-disable max-line-length */

.sticky-toolbar-mobile-item {
  display: flex;
  background-color: $ui-blue;
  flex: 1;

  .sr-only {
    @include sr-only;
  }

  & &__link {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  & &__icon {
    --component-icon-color: var(
      --component-sticky-toolbar-item-color-icon,
      var(--skin-color-primary-inverted, #{$ui-white})
    );

    width: 20px;
    height: 20px;
  }

  &.notify {
    animation: notify 2s ease-in-out infinite;
  }
}

@keyframes notify {
  0% {
    background-color: $ui-blue;
  }

  50% {
    background-color: $ui-green;
  }

  100% {
    background-color: $ui-blue;
  }
}
